import { StudyOverviewUnifyContentPackageType } from '../types/StudyOverviewContentModel';

export const StudyOverviewContentMock: StudyOverviewUnifyContentPackageType = {
  study_overview: [
    {
      metadata: {},
      title: '[M]title',
      overview: '[M]overview',
      description: '[M]description',
      uid: '[M]uid',
      _content_type_uid: 'study_overview',
    },
  ],
};
